import { DoctorRepository } from "@/domain/repository/doctor-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ResendDoctorAccountSetupEmailUsecase {
  constructor(private readonly doctorRepo: DoctorRepository) {}

  async execute(doctorUuid: string): Promise<SATResult<void, SATError>> {
    if (!doctorUuid) {
      throw new Error("[ResendDoctorAccountSetupEmailUsecase] doctorUuid is required");
    }

    return this.doctorRepo.resendAccountSetupEmail(doctorUuid);
  }
}
